module.exports = __webpack_public_path__ + "static/media/ansiedade.c186a911.jpg";